import React from 'react';

export function ArrowRightIcon({ className = '' }) {
    return (
        <svg className={className} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
        </svg>
    );
}

export default function ShopAuthLayout({ children }) {
    return (
        <div className="min-h-[100dvh] bg-[#f8f6f2] text-[#414141] lg:grid lg:grid-cols-[43%_57%]">
            <aside className="relative hidden min-h-[100dvh] overflow-hidden bg-[#2e2e2e] px-8 py-10 text-white lg:flex lg:flex-col xl:px-12 xl:py-14">
                {/* Logo pinned to the top; the statement block centres in whatever
                    height is left, so the panel reads balanced instead of
                    bottom-heavy at any viewport height. */}
                <div className="flex shrink-0 items-center gap-2.5">
                    <img
                        className="h-8 w-auto"
                        src="/PNG/carfido-logo-horizontal-white.png"
                        alt="CarFido"
                    />
                </div>

                <div className="relative z-10 flex min-h-0 flex-1 flex-col justify-center py-10">
                    <div className="max-w-md">
                        <p className="text-[10px] font-black uppercase tracking-[0.22em] text-[#ffaf24] xl:text-[11px]">The service desk, simplified</p>
                        <h1 className="mt-3 text-[26px] font-black leading-tight tracking-tight xl:text-3xl">Keep the bay moving.</h1>
                        <p className="mt-3 text-[13px] font-semibold leading-relaxed text-[#dfdfdf] xl:text-sm">
                            Jobs, conversations, and customer trust in one clear view. Built for the people who keep cars on the road.
                        </p>
                        <div className="mt-8 grid grid-cols-2 gap-3">
                            <div className="rounded-2xl border border-white/15 bg-white/5 p-4">
                                <p className="font-mono text-[11px] font-black text-[#ffaf24]">01</p>
                                <p className="mt-4 text-[12px] font-bold leading-snug text-white">Know what needs attention.</p>
                            </div>
                            <div className="rounded-2xl border border-white/15 bg-white/5 p-4">
                                <p className="font-mono text-[11px] font-black text-[#ffaf24]">02</p>
                                <p className="mt-4 text-[12px] font-bold leading-snug text-white">Keep customers in the loop.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pointer-events-none absolute -bottom-28 right-[-12rem] h-[22rem] w-[22rem] rounded-full border-[36px] border-[#8f8350]/45" />
            </aside>

            {/* my-auto rather than items-center: it centres when there is room and
                still lets a tall form (signup step 1) scroll without clipping the
                top, which items-center does on an overflowing flex child. */}
            <main className="flex min-h-[100dvh] justify-center px-4 py-8 sm:px-8 sm:py-10 lg:px-12 xl:px-16">
                <div className="my-auto w-full max-w-[420px] sm:max-w-[460px]">
                    <div className="mb-8 flex items-center gap-2.5 lg:hidden">
                        <img
                            className="h-8 w-auto"
                            src="/PNG/carfido-logo-horizontal.png"
                            alt="CarFido"
                        />
                    </div>
                    {children}
                </div>
            </main>
        </div>
    );
}
